export enum GESTION_CLIENTES_TYPES {
  // LISTAR CLIENTES = LC
  LC_SET_ARRAY_CLIENTES = 'LC_SET_ARRAY_CLIENTES',
  LC_SET_CLIENTES = 'LC_SET_CLIENTES',
  LC_FORM_BUSCAR = 'LC_FORM_BUSCAR',
  LC_CLEAR_FORM_BUSCAR = 'LC_CLEAR_FORM_BUSCAR',
  LC_CLEAR = 'LC_CLEAR',
  LC_SET_CLIENTE_SELECCIONADO = 'LC_SET_CLIENTE_SELECCIONADO',
  LC_SHOW_MODAL_ELIMINAR_CLIENTE = 'LC_SHOW_MODAL_ELIMINAR_CLIENTE',
  LC_SHOW_MODAL_ESTATUS = 'LC_SHOW_MODAL_ESTATUS',
  LC_SET_VERIFICACIONES = 'LC_SET_VERIFICACIONES',
  LC_SHOW_MODAL_VERIFICACION = 'LC_SHOW_MODAL_VERIFICACION',

  // EDITAR CLIENTE = EC
  EC_FORM_HANDLE_CHANGE = 'EC_FORM_HANDLE_CHANGE',
  EC_FORM_ADD_ERROR = 'EC_FORM_ADD_ERROR',
  EC_SET_CLIENTE_SELECCIONADO = 'EC_SET_CLIENTE_SELECCIONADO',
  EC_CLEAR = 'EC_CLEAR',

  // AGREGAR CLIENTE (carga masiva) = AC
  AC_SET_FILE_DATA_CARGADA = 'AC_SET_FILE_DATA_CARGADA',
  AC_CLEAR_FILE_DATA = 'AC_CLEAR_FILE_DATA',
}
